import Select from "react-select";
import { fieldLabel } from "./inputTheme";

const customStyles = {
  input: (provided) => ({
    ...provided,
    color: "#1e293b",
    margin: 0,
    padding: 0,
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#94a3b8",
  }),
  control: (provided, state) => ({
    ...provided,
    minHeight: "42px",
    borderRadius: "0.75rem",
    borderColor: state.isFocused ? "#10b981" : "#cbd5e1",
    boxShadow: state.isFocused ? "0 0 0 4px rgba(16, 185, 129, 0.2)" : "none",
    transition: "all .2s ease",
    "& input:focus": {
      outline: "none",
      boxShadow: "none",
    },
    "&:hover": {
      borderColor: state.isFocused ? "#10b981" : "#94a3b8",
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "0 12px",
  }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: state.isFocused ? "#059669" : "#64748b",
    "&:hover": { color: "#047857" },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#059669"
      : state.isFocused
      ? "rgba(16, 185, 129, 0.12)"
      : "transparent",
    color: state.isSelected ? "white" : "inherit",
    cursor: "pointer",
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "0.75rem",
    border: "1px solid #e2e8f0",
    boxShadow: "0 12px 32px rgba(2, 6, 23, 0.15)",
    overflow: "hidden",
  }),
};

const AutoCompleteInput = ({
  noOptionsMessage = "Nenhum registro encontrado",
  options,
  onChange,
  isLoading,
  label,
  name,
  value,
  disabled = false,
}) => {
  const selectedOption =
    options && options.find((option) => option.value == value);

  return (
    <div className="w-full">
      {label && (
        <label htmlFor={name} className={fieldLabel}>
          {label}
        </label>
      )}

      <Select
        noOptionsMessage={() => noOptionsMessage}
        options={options}
        onChange={onChange}
        placeholder="Selecione..."
        isLoading={isLoading}
        name={name}
        value={selectedOption || null}
        getOptionLabel={(option) => option.label}
        getOptionValue={(option) => option.value}
        styles={{
          ...customStyles,
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
          }),
          menu: (base) => ({
            ...base,
            zIndex: 9999,
          }),
        }}
        isDisabled={disabled}
        menuPortalTarget={document.body}
        menuPosition="absolute"
      />
    </div>
  );
};

export default AutoCompleteInput;
